import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=5a23e45b&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=5a23e45b&lang=scss&scoped=true&"
import style1 from "./feedback.vue?vue&type=style&index=1&id=5a23e45b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23e45b",
  null
  
)

component.options.__file = "feedback.vue"
export default component.exports